import { GETTING_RESULTS, GET_RESULTS, RESULTS_ERROR } from "../types";

const initialState = {
    results: [],
    loadingResults: true,
    resultsError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_RESULTS:
        return {
            ...state,
            loadingResults :action.payload,
        }
        case GET_RESULTS:
        return{
            ...state,
            loadingResults:false,
            resultsError:  null,
            results: action.payload,
        }
        case RESULTS_ERROR:
        return{
            ...state,
            loadingResults:false,
            resultsError: action.payload 
        }
        default: return state
    }

}